import request from './request'

export function initFun(){
    return request({
        url: '/init',
        method: 'post',
    })
}